import React from 'react';
import Badge from './Badge';

const EventProblemBadge = ({type, classes = ''}) => (
    <div className={`atbd_listing_thumbnail_area atbd_thumbnail_overlay_content ${classes}`}>
        <ul className="atbd_upper_badge">
            {<Badge type={type} description={type} />}
        </ul>
    </div>
);

export default EventProblemBadge;

